/*
 * Styles for <data-table-paginator>.
 *
 * These are the LIVE paginator styles. The parent table's stylesheet also once
 * carried a `data-table-paginator .page-item ...` block, but this component
 * renders into its own shadow root, so those descendant selectors could never
 * match and have been removed. Only a host-level rule can style this element
 * from the parent.
 *
 * COLOUR RULE: no raw hex - every colour is a semantic role from
 * src/styles/tokens.css. See data-table.ts for why the CSS is imported.
 */

:host {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0.25rem;
  align-items: center;
}

.page-item {
  display: flex;
}

/* Page numbers read as accent-coloured text on the table surface, so they use
   the accent TEXT role, which brightens in dark for legibility - not the accent
   fill role, which stays at brand value. */
.page-item .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--agwa-accent-text);
  background: transparent;
  border: 1px solid var(--agwa-divider);
  border-radius: 0.375rem;
  text-decoration: none;
  cursor: pointer;
  transition: all 160ms ease;
}

.page-item .page-link:hover {
  background: var(--agwa-accent-soft);
  border-color: var(--agwa-accent);
}

/* The active page is an accent FILL, so its label uses --agwa-on-accent, which
   deliberately does not invert between themes. */
.page-item.active .page-link {
  background: linear-gradient(
    120deg,
    var(--agwa-accent),
    var(--agwa-accent-bright)
  );
  color: var(--agwa-on-accent);
  border-color: transparent;
  font-weight: 600;
  cursor: default;
  box-shadow: 0 2px 8px var(--agwa-accent-glow);
}

/* Inactive control - the one sanctioned use of --agwa-text-subtle, which sits
   below WCAG AA and is permitted only because SC 1.4.3 exempts disabled UI. */
.page-item.disabled .page-link {
  color: var(--agwa-text-subtle);
  background: transparent;
  border-color: var(--agwa-divider);
  cursor: not-allowed;
  opacity: 0.5;
}

.page-item.disabled .page-link:hover {
  background: transparent;
  border-color: var(--agwa-divider);
}
